module.exports = __webpack_public_path__ + "img/ringDiameter.85eef04.webp";